export default __webpack_public_path__ + "static/media/rightArrow.e24313a0.svg";